import { faUsers, faPhone, faWallet, faChartArea, faCloud } from '@fortawesome/pro-solid-svg-icons';

export default {
  accounts: {
    path: '/users',
    icon: faUsers,
    label: 'Utilisateurs',
    advantages: ["Sécurité d'accès", 'Conformité RGPD', 'Gestion des rôles'],
  },
  payments: {
    path: '/payments',
    icon: faWallet,
    label: 'Transactions',
    advantages: ['Connexion avec Stripe', 'Stockage sécurisée', 'Gestion des taxes'],
  },
  stats: {
    path: '/stats',
    icon: faChartArea,
    label: 'Statistiques',
    advantages: ['Gestion en temps réel', 'Désengorgement des flux', 'Visualisation du trafic'],
  },
  clouds: {
    path: '/clouds',
    icon: faCloud,
    label: 'Clouds',
    advantages: ['Gestion centralisée', 'Support avancé', 'Analyse et monitoring'],
  },
  'phone-support': {
    path: '/phone',
    icon: faPhone,
    label: 'Support Téléphonique',
    advantages: ['Support avancé', "Ligne d'astreinte"],
  },
};
